import apiProduct from '@/api/ecommerce/product';

const defaultState = () => ({
	listProduct: [],
	paginationProduct: '',
	listProductCategory: [],
	paginationProductCategory: '',
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
	setProduct(state, data) {
		state.listProduct = data.data
		state.paginationProduct = data.pagination;
	},
	setProductCategory(state, data) {
		state.listProductCategory = data.data
		state.paginationProductCategory = data.pagination;
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataProduct(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getProduct({ commit, dispatch }, params) {
		apiProduct.getDataProduct(params).then(({ data: { data } }) => {
			commit('setProduct', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setProduct', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async exportProduct({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiProduct.exportProduct(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Produk'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getProductCategory({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiProduct.getDataProductCategory(params).then(({ data: { data } }) => {
				commit('setProductCategory', { data: data.results, pagination: data.pagination });
				resolve(data.results)
			}).catch((err) => {
				commit('setProductCategory', { data: [], pagination: {} });
				const data = err.response.data
				dispatch("errorHandler", data)
				reject([])
			});
		})
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};